import type { PerfSnapshot } from '../engine/PerfMonitor';

/**
 * Ein einziges, geteiltes Objekt zwischen Spielschleife und HUD.
 *
 * Die Schleife schreibt hier hinein, die HUD-Komponenten lesen in ihrem
 * eigenen rAF und schreiben direkt in DOM-Refs. So gibt es null
 * React-Rerenders im 60-fps-Takt.
 */
export interface Telemetry {
  speedKmh: number;
  gear: 'V' | 'N' | 'R';
  steer: number;
  throttle: number;
  brake: number;
  handbrake: boolean;
  airborne: boolean;
  upright: number;
  missionTitle: string;
  missionHint: string;
  missionProgress: number;
  perf: PerfSnapshot | null;
}

export const telemetry: Telemetry = {
  speedKmh: 0,
  gear: 'N',
  steer: 0,
  throttle: 0,
  brake: 0,
  handbrake: false,
  airborne: false,
  upright: 1,
  missionTitle: '',
  missionHint: 'FAHRE ZUM LEUCHTENDEN FELD',
  missionProgress: 0,
  perf: null,
};
